import { z } from "zod";

const translationPath = "page.register.totemDevice.errors.";

const siteAppSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "site_app" }
);

export const totemDeviceSchema = z
  .object({
    id: z.string().optional(),
    name: z.string().min(1, translationPath + "name"),
    devicePassword: z.string().nullish(),
    changePassword: z.boolean().optional(),
    integrationQueues: z
      .string()
      .min(1, translationPath + "integration_queues"),
    token4uBus: z.string().min(1, translationPath + "token_4uBus"),
    siteApp: siteAppSchema,
    observation: z.string().nullish(),
    enable: z.boolean(),
  })
  .superRefine((val, ctx) => {
    if (val.id && val.changePassword && !val.devicePassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["devicePassword"],
        message: `${translationPath + "device_password"}`,
      });
    }
    if (!val.id && !val.devicePassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["devicePassword"],
        message: `${translationPath + "device_password"}`,
      });
    }
  });
export type TTotemDeviceForm = z.infer<typeof totemDeviceSchema>;
